module.exports = __webpack_public_path__ + "img/square-minus.56fee5c8.svg";